import Form from '../../../../../../components/form';
import request from '../../../../../../utils/request';
import ModalList from './components/modal_list.vue';
import BarCodeList from './components/bar_code_list.vue';
import AddressList from './components/address_list.vue';

formCreate.component('ModalList', ModalList);
formCreate.component('BarCodeList', BarCodeList);
formCreate.component('AddressList', AddressList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'main_form',
      formParentCode: 'CRM20250818000000004',
      buttonText: {
        submit: '保存',
      },
      buttons: {
        submitAudit: this.formConfig.code !== 'view',
      },
    };
  },
  methods: {

    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'terminalName') { // 选择终端
        v.props = {
          ...v.props,
          params: {
            functionCode: 'terminal_list',
            paramData: {
              enableStatus: '009',
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'productName') { // 选择产品
        v.props = {
          ...v.props,
          params: {
            functionCode: 'product_list',
            paramData: {
              isShelf: 'Y',
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'configName') { // 选择宴席政策
        v.props = {
          ...v.props,
          params: {
            functionCode: 'banquet_list',
            paramData: {
              banquetType: '0',
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'refereeName') { // 选择推荐人
        v.props = {
          ...v.props,
          params: {
            functionCode: 'person_list',
            paramData: {
              enableStatus: '009',
            },
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'executorName') { // 选择执行人
        v.props = {
          ...v.props,
          params: {
            functionCode: 'executor_list',
          },
          getValue: (field) => this.getFieldValue(field),
          title: v.title,
        };
      }
      if (v.field === 'applyTableNum') { //  申请桌数
        v.props = {
          ...v.props,
          min: 0,
          precision: 0,
          controls: false,
        };
      }
      if (v.field === 'applyBottleNum') { // 申请瓶数
        v.props = {
          ...v.props,
          min: 0,
          precision: 0,
          controls: false,
        };
      }
      if (v.field === 'fileList') {
        v.props = {
          ...v.props,
          fileMsg: '请上传: pdf,docx,xlsx,ppt,png,jpg等类型，且不超过100M',
        };
      }
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      const terminalName = this.getRule('terminalName');
      const productName = this.getRule('productName');
      const configName = this.getRule('configName');
      const refereeName = this.getRule('refereeName');
      const executorName = this.getRule('executorName');
      const boxList = this.getRule('boxList');
      // 终端
      terminalName.on.change = (e) => {
        executorName.props.params = {
          ...executorName.props.params,
          paramData: {
            ...executorName.props.params.paramData,
            terminalCode: e && e.length > 0 ? e[0].terminalCode : null,
          },
        };
        boxList.props = {
          ...boxList.props,
          terminalCode: e && e.length > 0 ? e[0].terminalCode : null,
        };
        if (e && e.length > 0) {
          this.setValue({
            terminalName: e[0].terminalName,
            terminalCode: e[0].terminalCode,
            executorName: null,
            executorCode: null,
            executorOrgCode: null,
            executorOrgName: null,
            boxList: [],
          });
        } else {
          this.setValue({
            terminalName: null,
            terminalCode: null,
            executorName: null,
            executorCode: null,
            executorOrgCode: null,
            executorOrgName: null,
            boxList: [],
          });
        }
      };
      // 产品
      productName.on.change = (e) => {
        configName.props.params = {
          ...configName.props.params,
          paramData: {
            ...configName.props.params.paramData,
            productCode: e && e.length > 0 ? e[0].materialCode : null,
          },
        };
        executorName.props.params = {
          ...executorName.props.params,
          paramData: {
            ...executorName.props.params.paramData,
            productCode: e && e.length > 0 ? e[0].materialCode : null,
          },
        };
        boxList.props = {
          ...boxList.props,
          productCode: e && e.length > 0 ? e[0].materialCode : null,
        };
        if (e && e.length > 0) {
          this.setValue({
            productName: e[0].materialName,
            productCode: e[0].materialCode,
            executorName: null,
            executorCode: null,
            executorOrgCode: null,
            executorOrgName: null,
            configName: null,
            configCode: null,
            boxList: [],
          });
        } else {
          this.setValue({
            productName: null,
            productCode: null,
            executorName: null,
            executorCode: null,
            executorOrgCode: null,
            executorOrgName: null,
            configName: null,
            configCode: null,
            boxList: [],
          });
        }
      };
      // 宴席政策
      configName.on.change = (e) => {
        if (e && e.length > 0) {
          this.setValue({
            configName: e[0].configName,
            configCode: e[0].configCode,
          });
        } else {
          this.setValue({
            configName: null,
            configCode: null,
          });
        }
      };
      // 推荐人
      refereeName.on.change = (e) => {
        if (e && e.length > 0) {
          const contactPhone = ((e[0].contacts || []).find((v) => v.contactMain === '1') || {}).contactPhone || null;
          this.setValue({
            refereeName: e[0].terminalName,
            refereeCode: e[0].terminalCode,
            refereePhone: contactPhone,
          });
        } else {
          this.setValue({
            refereeName: null,
            refereeCode: null,
            refereePhone: null,
          });
        }
      };
      // 执行人
      executorName.on.change = (e) => {
        configName.props.params = {
          ...configName.props.params,
          paramData: {
            ...configName.props.params.paramData,
            orgCode: e && e.length > 0 ? e[0].orgCode : null,
          },
        };
        if (e && e.length > 0) {
          this.setValue({
            executorName: e[0].userName,
            executorCode: e[0].userCode,
            executorOrgCode: e[0].orgCode,
            executorOrgName: e[0].orgName,
            subCompanyCode: e[0].companyOrgCode,
            subCompanyName: e[0].companyOrgName,
            configName: null,
            configCode: null,
          });
        } else {
          this.setValue({
            executorName: null,
            executorCode: null,
            executorOrgCode: null,
            executorOrgName: null,
            subCompanyCode: null,
            subCompanyName: null,
            configName: null,
            configCode: null,
          });
        }
      };
      // 消费者手机号
      const consumerPhone = this.getRule('consumerPhone');
      consumerPhone.props = {
        ...consumerPhone.props,
        maxlength: 11,
      };
      consumerPhone.validate = [
        ...consumerPhone.validate,
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确消费者手机号', trigger: 'change' },
      ];
      const banquetTime = this.getRule('banquetTime');
      banquetTime.props = {
        ...banquetTime.props,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < new Date() - 8.64e7; // 如果没有后面的-8.64e7就是不可以选择今天的
          },
        },
      };
      banquetTime.on.change = (e) => {
        configName.props.params = {
          ...configName.props.params,
          paramData: {
            ...configName.props.params.paramData,
            banquetTime: e,
          },
        };
        this.setValue({
          configName: null,
          configCode: null,
        });
      };
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        request
          .post('/cps/v1/cpsbanquetreport/query', {
            id: this.formConfig.row.id,
          })
          .then((res) => {
            if (res.success) {
              const { result } = res;
              executorName.props.params = {
                ...executorName.props.params,
                paramData: {
                  ...executorName.props.params.paramData,
                  terminalCode: result.terminalCode ? result.terminalCode : null,
                  productCode: result.productCode ? result.productCode : null,
                },
              };
              boxList.props = {
                ...boxList.props,
                terminalCode: result.terminalCode ? result.terminalCode : null,
                productCode: result.productCode ? result.productCode : null,
              };
              configName.props.params = {
                ...configName.props.params,
                paramData: {
                  ...configName.props.params.paramData,
                  productCode: result.productCode ? result.productCode : null,
                  orgCode: result.executorOrgCode ? result.executorOrgCode : null,
                  banquetTime: result.banquetTime ? result.banquetTime : null,
                },
              };
              if (result.boxList) {
                result.boxList = result.boxList.map((v) => {
                  const obj = v;
                  obj.barCode = obj.boxCode;
                  return obj;
                });
              }

              this.setValue(result);
            }
          });
      }
    },
    // 提交
    async submit(type) {
      console.log(type);
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/cps/v1/cpsbanquetreport/save';
        const params = formData;
        params.banquetSource = '1';
        params.sourceType = 'HT';
        delete params.title1;
        if (this.formConfig.code === 'edit') {
          url = '/cps/v1/cpsbanquetreport/update';
          params.id = this.formConfig.row.id;
        }
        // 跳转下一步
        if (type === 2) {
          params.isSubmit = 1;
          const { success } = await request.post(url, params);
          if (success) {
            this.$message({
              type: 'success',
              message: '保存成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        } else {
          params.isSubmit = 0;
          const { success } = await request.post(url, params);
          if (success) {
            this.$message({
              type: 'success',
              message: '保存成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        }
      }
    },
  },
};
